export {
  TargetCard,
  Configuration,
  DetectionOption,
  CommunicationOption,
  NFCUtils
}

// must be updated
let syslog = () => {}

class TargetCard {
  constructor(e, r, t, o, s, i) {
    this.idm = e, this.pmm = r, this.uid = t, this.pupi = o, this.systemCode = s, this.baudRate = i
  }
}
class Configuration {
  constructor(e, r, t, o) {
    this.ackTimeout = e, this.receiveTimeout = r, this.autoBaudRate = t, this.autoDeviceSelect = o
  }
}
class DetectionOption {
  constructor(e, r, t, o, s, i) {
    this.systemCode = e, this.timeSlot = r, this.requestSystemCode = t, this.requestBaudRate = o, this.fsdi = s, this.cid = i
  }
}
class CommunicationOption {
  constructor(e, r, t, o, s) {
    this.mifareAuthentication = e, this.key = r, this.keyType = t, this.blockNumber = o, this.uid = s
  }
}

class NFCUtils {

  static def_val(param, def) {
    return (param === undefined) ? def : param;
  }

  static dec2hexString(dec) {
    //return '0x' + ('00' + (dec+0x00).toString(16).substr(-4).toUpperCase()).substr(-2);
    return ('00' + (dec+0x00).toString(16).substr(-4).toUpperCase()).substr(-2);
  }

  static format_cmd(command=[]) {
    if(command.length==0) {
      console.error('!!!! Parameter is not set !!!!')
      return '<<< ERROR >>>'
    }
    let _c_out =[]
    command.forEach( digit => {
      _c_out.push(NFCUtils.dec2hexString(digit))
      _c_out.push(NFCUtils.dec2hexString(digit))
    })
    return _c_out.join(' ')
  }
  static bytes2hexs(bytes, sep) {
    let str;

    sep = this.def_val(sep, ' ');

    return bytes.map(function(byte) {
      str = byte.toString(16);
      return byte < 0x10 ? '0'+str : str;
    }).join(sep).toUpperCase();
  }

  static array_tohexs(array, offset, length) {
    let temp;

    offset = this.def_val(offset, 0);
    length = this.def_val(length, array.length - offset);

    temp = this.array_slice(array, offset, length );
    return this.bytes2hexs(temp, '');
  }

  static __array_copy(dest, dest_offset, src, src_offset, length) {
    let idx;
    let out = dest.slice()

    src_offset = this.def_val(src_offset, 0);
    length = this.def_val(length, src.length);

    for (idx = 0; idx < length; idx++) {
      out[dest_offset + idx] = src[src_offset + idx];
    }

    return out
  }

  static array_copy(dest, dest_offset, src, src_offset, length) {
    let idx;

    src_offset = this.def_val(src_offset, 0);
    length = this.def_val(length, src.length);

    for (idx = 0; idx < length; idx++) {
      dest[dest_offset + idx] = src[src_offset + idx];
    }

    return dest;
  }

  static array_slice(array, offset, length) {
    length = this.def_val(length, array.length - offset);
    let result = [];
    this.array_copy(result, 0, array, offset, length);

    return result;
  }

  static array_compare(e, r, t, o, s) {
    let i;
    for (i = 0; i < s; i++) {
      if (void 0 === e[r + i]) return -1;
      if (void 0 === t[o + i]) return -1;
      if (e[r + i] != t[o + i]) return -1
    }
    return 0
  }

  static dataview_to_array(e) {
    let r, t;
    for (r = new Array(e.byteLength), t = 0; t < e.byteLength; t++) r[t] = e.getUint8(t);
    return r
  }

  static array_append(e, r, t, o) {
    let s;
    for (t = this.def_val(t, 0), o = this.def_val(o, r.length - t), s = 0; s < o; s++) e.push(r[t + s]);
    return e
  }

  static array_set_uint16l(e, r, t) {
    e[r] = 255 & t, e[r + 1] = t >> 8 & 255
  }

  static array_get_uint16l(e, r) {
    return e[r + 1] << 8 | e[r]
  }

  static array_get_uint32l(e, r) {
    return e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]
  }

  static enableDebugLog(param = false) {
    let syslog = () => {}
    let stackTrace = () => {
      let err = new Error()
      let err_out = []
      err.stack.split("\n").forEach( line => {
        let reg_exp = new RegExp(location.href)
        if(line.match('^Error')==null) {
          let _tmp_err_out = line.replace(/^[ ].*at[ ]/, '').replace(/scripts\//, '').replace(reg_exp,'').replace(' (', "\t(").split("\t")
          err_out.push([_tmp_err_out.pop(), _tmp_err_out.shift()].join("\t"))
        }
      })
      return err_out.join("\n")
    }

    if(param == true) {
      console.log('[Set to show debug log]')
      syslog = (msg) => {
        //console.log(stackTrace())
        console.log('[DEBUG] ', msg)
      }
    }

    return syslog
  }

  static wait_async(e) {
    return new Promise((r, t) => {
      setTimeout(r, e)
    })
  }

}
